export const MANAGER_LIST = 'school/school-detail/manager/MANAGER_LIST';
export const NEW_MANAGER_LIST = 'school/school-detail/manager/NEW_MANAGER_LIST';
export const MANAGER = 'school/school-detail/manager/MANAGER';
export const BATCH_CREATE_MANAGER = 'school/school-detail/manager/BATCH_CREATE_MANAGER';
export const TOGGLE_FREEZE_MANAGER = 'school/school-detail/manager/TOGGLE_FREEZE_MANAGER';
export const DELETE_MANAGER = 'school/school-detail/manager/DELETE_MANAGER';
export const SCHOOL_NAME = 'school/school-detail/SCHOOL_NAME';
export const INFO = 'school/school-detail/INFO';



// WEBPACK FOOTER //
// ./src/store/modules/school/school-detail/manager/types.js